import angular from "angular";

angular
    .module('app')
    .component('courseVideoPreview', {
        template: require('./course-video-preview.html'),
        controller: ['$sce', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($sce) {

    let $ctrl = this;
    $ctrl.videoHtml = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        if ($ctrl.course.vimeo_video_link) {
            $ctrl.videoHtml = $sce.trustAsHtml($ctrl.course.vimeo_video_html);
        } else {
            $ctrl.video = $ctrl.course.preview_video;
        }
    };
}
